module.exports = __webpack_public_path__ + "img/banner-maskex2.ea5d2452.webp";